/** One place for cache keys, so invalidation never guesses. */
export const qk = {
  me: ["me"] as const,
  sessions: ["auth", "sessions"] as const,
  passkeys: ["auth", "passkeys"] as const,

  plans: ["reference", "plans"] as const,
  sectors: ["reference", "sectors"] as const,
  todoCategories: ["reference", "todo-categories"] as const,
  badgeCatalogue: ["reference", "badges"] as const,

  business: (id: string) => ["business", id] as const,
  members: (id: string) => ["business", id, "members"] as const,
  companiesHouse: (id: string, q: string) => ["business", id, "companies-house", q] as const,

  subscription: (id: string) => ["billing", id, "subscription"] as const,
  invoices: (id: string) => ["billing", id, "invoices"] as const,

  metricPeriods: (id: string, months: number, endPeriod?: string) =>
    ["metrics", id, "periods", months, endPeriod ?? "current"] as const,
  metricPeriod: (id: string, period: string) => ["metrics", id, "period", period] as const,
  valuation: (id: string, period?: string) => ["metrics", id, "valuation", period ?? "latest"] as const,
  targets: (id: string) => ["metrics", id, "targets"] as const,

  gamification: (id: string) => ["gamification", id, "me"] as const,
  badges: (id: string) => ["gamification", id, "badges"] as const,
  xpHistory: (id: string) => ["gamification", id, "xp-history"] as const,
  leaderboard: (id: string) => ["gamification", id, "leaderboard"] as const,

  todos: (id: string, filters: Record<string, unknown>) => ["todos", id, filters] as const,
  todosRoot: (id: string) => ["todos", id] as const,
  focus: (id: string) => ["todos", id, "focus"] as const,

  products: (id: string) => ["portfolio", id, "products"] as const,
  avatars: (id: string) => ["portfolio", id, "avatars"] as const,

  files: (id: string) => ["files", id] as const,
  fileSearch: (id: string, query: string) => ["files", id, "search", query] as const,

  raiConversations: (id: string) => ["rai", id, "conversations"] as const,
  raiConversation: (id: string, convId: string) => ["rai", id, "conversation", convId] as const,
  raiUsage: (id: string) => ["rai", id, "usage"] as const,

  educationBrowse: (id: string) => ["education", id, "browse"] as const,
  educationSearch: (id: string, filters: Record<string, unknown>) =>
    ["education", id, "search", filters] as const,
  educationItem: (id: string, slug: string) => ["education", id, "item", slug] as const,
  educationProgress: (id: string) => ["education", id, "progress"] as const,

  notificationPreferences: ["notifications", "preferences"] as const,

  adminOverview: ["admin", "overview"] as const,
  adminBusinesses: (filters: Record<string, unknown>) => ["admin", "businesses", filters] as const,
  adminBusiness: (id: string) => ["admin", "business", id] as const,
  adminTasks: (filters: Record<string, unknown>) => ["admin", "tasks", filters] as const,
  adminInvites: (filters: Record<string, unknown>) => ["admin", "invites", filters] as const,
  adminStaff: ["admin", "staff"] as const,
  adminScoring: ["admin", "scoring-config"] as const,
  adminCronRuns: (job?: string) => ["admin", "cron", "runs", job ?? "all"] as const,
} as const;
